import { ValidationRule, WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import { formRequiredRules } from '../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { BRAND_WIDGET_LAYOUT_TYPE_V2, BrandWidgetDetailV2 } from '../../../../../types/widget';
import { validateStringLength } from '../../../../../lib/utils/form/validators';

export const EXPOSURE_WIDGET_MAX_COUNT: { [key: string]: number } = {
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4]: 4,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: 4,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: 4,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1]: 4,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE]: 5,
};

export const EXPOSURE_WIDGET_CONTENTS_MAX_COUNT: { [key: string]: number } = {
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4]: 0,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2]: 15,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1]: 50,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1]: 50,
  [BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE]: 50,
};

type BrandWidgetFormRuleReturnType = {
  mainTitle: { rules: ValidationRule[] };
  subTitle: { rules: ValidationRule[] };
  memo: { rules: ValidationRule[] };
  brandList: { max?: number };
  widgetBrandList: { rules: ValidationRule[] };
  exposureWidgetItemBrands: {
    innerRules: {
      attachment: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
      title: {
        rules: ValidationRule[];
      };
      contents: {
        hideIf: boolean;
        rules: ValidationRule[];
      };
    };
  };
};

interface FormRulesProps {
  form: WrappedFormUtils;
  initialValue?: Partial<BrandWidgetDetailV2>;
}

export const useBrandWidgetFormRules = (props: FormRulesProps): BrandWidgetFormRuleReturnType => {
  const { form, initialValue } = props;
  const { layoutType = initialValue?.layoutType } = form.getFieldsValue(['layoutType']) as Pick<
    BrandWidgetDetailV2,
    'layoutType'
  >;

  return {
    mainTitle: {
      rules: [
        formRequiredRules(true, REQUIRED_MSG),
        { validator: validateStringLength({ max: 20, message: '위젯 타이틀의 글자 수는 최대 20자입니다' }) },
      ],
    },
    subTitle: {
      rules: [
        { validator: validateStringLength({ max: 20, message: '위젯 서브 타이틀의 글자 수는 최대 20자입니다.' }) },
      ],
    },
    memo: {
      rules: [{ validator: validateStringLength({ max: 1000, message: '메모는 최대 글자 수는 1,000자입니다.' }) }],
    },
    brandList: { max: layoutType && EXPOSURE_WIDGET_MAX_COUNT[layoutType] },
    widgetBrandList: { rules: [{ required: true, type: 'array', message: '위젯 아이템을 등록해주세요.' }] },
    exposureWidgetItemBrands: {
      innerRules: {
        attachment: {
          hideIf:
            layoutType !== BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE &&
            layoutType !== BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_NX1 &&
            layoutType !== BRAND_WIDGET_LAYOUT_TYPE_V2.SCROLL_BLANK_NX1,
          rules: [{ required: true, type: 'array', message: REQUIRED_MSG }],
        },
        title: {
          rules: [
            {
              required: layoutType !== BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4,
              message: REQUIRED_MSG,
            },

            {
              validator: validateStringLength({
                max: 20,
                message: '글자 수는 최대 20자입니다.',
              }),
            },
          ],
        },
        contents: {
          hideIf: layoutType === BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4,
          rules: [
            formRequiredRules(
              layoutType === BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_2X2 || layoutType === BRAND_WIDGET_LAYOUT_TYPE_V2.SWIPE,
              REQUIRED_MSG,
            ),
            {
              validator: validateStringLength({
                max: EXPOSURE_WIDGET_CONTENTS_MAX_COUNT[layoutType || BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4],
                message: `글자 수는 최대 ${
                  EXPOSURE_WIDGET_CONTENTS_MAX_COUNT[layoutType || BRAND_WIDGET_LAYOUT_TYPE_V2.GRID_1X4]
                }자입니다.`,
              }),
            },
          ],
        },
      },
    },
  };
};
